import type { EditorHistoryCommand } from '@/editor/history/types'
import { getMockupHistoryBridge } from '@/editor/history/mockupEditorBridge'
import type { MockupBackgroundModeId } from '@/editor/history/mockupEditorBridge'

/**
 * 背景纯色 hex 变更。
 */
export class SetBackgroundHexCommand implements EditorHistoryCommand {
  readonly label = 'Set background color'

  private readonly before: string

  private readonly after: string

  /**
   * @param before - 变更前
   * @param after - 变更后
   */
  constructor(before: string, after: string) {
    this.before = before
    this.after = after
  }

  /** @inheritdoc */
  revert(): void {
    getMockupHistoryBridge().backgroundHex.value = this.before
  }

  /** @inheritdoc */
  redo(): void {
    getMockupHistoryBridge().backgroundHex.value = this.after
  }
}

/**
 * 背景模式（含透明等）变更。
 */
export class SetBackgroundModeCommand implements EditorHistoryCommand {
  readonly label = 'Set background mode'

  private readonly before: MockupBackgroundModeId

  private readonly after: MockupBackgroundModeId

  /**
   * @param before - 变更前
   * @param after - 变更后
   */
  constructor(before: MockupBackgroundModeId, after: MockupBackgroundModeId) {
    this.before = before
    this.after = after
  }

  /** @inheritdoc */
  revert(): void {
    getMockupHistoryBridge().backgroundMode.value = this.before
  }

  /** @inheritdoc */
  redo(): void {
    getMockupHistoryBridge().backgroundMode.value = this.after
  }
}

/**
 * 单个渐变色标 hex 变更。
 */
export class SetGradientStopHexCommand implements EditorHistoryCommand {
  readonly label = 'Set gradient stop color'

  private readonly stopId: string

  private readonly before: string

  private readonly after: string

  /**
   * @param stopId - 色标 id
   * @param before - 变更前 hex
   * @param after - 变更后 hex
   */
  constructor(stopId: string, before: string, after: string) {
    this.stopId = stopId
    this.before = before
    this.after = after
  }

  /** @inheritdoc */
  revert(): void {
    const row = getMockupHistoryBridge().gradientStops.value.find((s) => s.id === this.stopId)
    if (row) row.hex = this.before
  }

  /** @inheritdoc */
  redo(): void {
    const row = getMockupHistoryBridge().gradientStops.value.find((s) => s.id === this.stopId)
    if (row) row.hex = this.after
  }
}
